import LBox from "@components/LBox";
import { BUTTON_SPACING } from "../../config";

const Container = ({ children }: { children: React.ReactNode }) => {
  return (
    <LBox
      flexDirection="row"
      alignItems="center"
      justifyContent="space-between"
      style={{
        gap: BUTTON_SPACING,
      }}
    >
      {children}
    </LBox>
  );
};

export default Container;
